/* =========================================================
   EVILRIPS — theme.js
   ========================================================= */
(function () {
  "use strict";

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector("[data-menu-toggle]");
  var mobileNav = document.querySelector("[data-mobile-nav]");
  var scrim = document.querySelector("[data-scrim]");
  var mobileClose = document.querySelector("[data-mobile-nav-close]");

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add("is-open");
    if (scrim) scrim.classList.add("is-open");
    document.body.style.overflow = "hidden";
    if (menuToggle) menuToggle.setAttribute("aria-expanded", "true");
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove("is-open");
    if (scrim) scrim.classList.remove("is-open");
    document.body.style.overflow = "";
    if (menuToggle) menuToggle.setAttribute("aria-expanded", "false");
  }
  if (menuToggle) menuToggle.addEventListener("click", openMobileNav);
  if (mobileClose) mobileClose.addEventListener("click", closeMobileNav);
  if (scrim) scrim.addEventListener("click", function(){ closeMobileNav(); closeCartDrawer(); });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector("[data-cart-drawer]");
  var cartToggleBtns = document.querySelectorAll("[data-cart-toggle]");
  var cartCloseBtn = document.querySelector("[data-cart-close]");
  var cartCountEls = document.querySelectorAll("[data-cart-count]");

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add("is-open");
    if (scrim) scrim.classList.add("is-open");
    document.body.style.overflow = "hidden";
    refreshCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    if (scrim && !mobileNav?.classList.contains("is-open")) scrim.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  cartToggleBtns.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });
  if (cartCloseBtn) cartCloseBtn.addEventListener("click", closeCartDrawer);

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "flex" : "none";
    });
  }

  function refreshCartDrawer() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.querySelector("[data-cart-items]");
    var footEl = document.querySelector("[data-cart-foot]");
    if (!itemsEl) return;
    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="er-cart-empty">Your stash is empty.<br>Time to rip something.</div>';
      if (footEl) footEl.style.display = "none";
      return;
    }
    if (footEl) footEl.style.display = "block";

    var html = "";
    cart.items.forEach(function (item) {
      html +=
        '<div class="er-cart-line" data-line-key="' + item.key + '">' +
          '<img src="' + (item.image || "") + '" alt="" loading="lazy">' +
          '<div style="flex:1">' +
            '<div class="er-cart-line__title">' + item.product_title + "</div>" +
            (item.variant_title ? '<div class="er-cart-line__meta">' + item.variant_title + "</div>" : "") +
            '<div class="er-cart-line__meta">Qty ' + item.quantity + ' &middot; ' + formatMoney(item.final_line_price) + "</div>" +
            '<a href="#" class="er-cart-line__remove" data-remove-line="' + item.key + '">Remove</a>' +
          "</div>" +
        "</div>";
    });
    itemsEl.innerHTML = html;

    var subtotalEl = document.querySelector("[data-cart-subtotal]");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.querySelectorAll("[data-remove-line]").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        var key = link.getAttribute("data-remove-line");
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(renderCartDrawer);
      });
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return "£" + (cents / 100).toFixed(2);
  }

  /* ---------- Add to cart (product form + card quick-add) ---------- */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-product-form]");
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector("[type=submit]");
    if (submitBtn) { submitBtn.setAttribute("disabled", "disabled"); submitBtn.dataset.label = submitBtn.textContent; submitBtn.textContent = "Adding..."; }

    var formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (submitBtn) submitBtn.textContent = "Sold out or unavailable";
        } else {
          if (submitBtn) submitBtn.textContent = "Added ✓";
          openCartDrawer();
        }
      })
      .catch(function () {
        if (submitBtn) submitBtn.textContent = "Something went wrong";
      })
      .finally(function () {
        setTimeout(function () {
          if (submitBtn) { submitBtn.removeAttribute("disabled"); submitBtn.textContent = submitBtn.dataset.label; }
        }, 1600);
      });
  });

  /* quick-add from product cards (no options) */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { openCartDrawer(); })
      .catch(function () {});
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    var stepBtn = e.target.closest("[data-qty-step]");
    if (!stepBtn) return;
    var wrap = stepBtn.closest("[data-qty-wrap]");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var dir = stepBtn.getAttribute("data-qty-step");
    var val = parseInt(input.value || "1", 10);
    val = dir === "up" ? val + 1 : Math.max(1, val - 1);
    input.value = val;
  });

  /* ---------- Sort dropdown ---------- */
  var sortSelect = document.querySelector("[data-sort-select]");
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Newsletter popup ---------- */
  (function initPopup() {
    var popup = document.querySelector("[data-newsletter-popup]");
    var popupScrim = document.querySelector("[data-newsletter-scrim]");
    if (!popup) return;

    var STORAGE_KEY = "evilrips_newsletter_dismissed";
    var delay = parseInt(popup.getAttribute("data-delay") || "6000", 10);

    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch (err) { /* storage unavailable, still allow popup */ }

    function showPopup() {
      popup.classList.add("is-open");
      if (popupScrim) popupScrim.classList.add("is-open");
    }
    function hidePopup(persist) {
      popup.classList.remove("is-open");
      if (popupScrim) popupScrim.classList.remove("is-open");
      if (persist) {
        try { localStorage.setItem(STORAGE_KEY, "1"); } catch (err) {}
      }
    }

    setTimeout(showPopup, delay);

    var closeBtn = popup.querySelector("[data-newsletter-close]");
    if (closeBtn) closeBtn.addEventListener("click", function () { hidePopup(true); });
    if (popupScrim) popupScrim.addEventListener("click", function () { hidePopup(true); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") hidePopup(true);
    });

    var form = popup.querySelector("[data-newsletter-form]");
    if (form) {
      form.addEventListener("submit", function () {
        try { localStorage.setItem(STORAGE_KEY, "1"); } catch (err) {}
      });
    }
  })();

  /* ---------- Variant selection (product page) ---------- */
  (function initVariants() {
    var form = document.querySelector("[data-product-form]");
    if (!form) return;
    var dataEl = form.querySelector("[data-variant-data]");
    var idInput = form.querySelector('input[name="id"]');
    var selects = form.querySelectorAll("[data-option-select]");
    if (!dataEl || !idInput || !selects.length) return;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function selectedOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }
    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function onVariantChange() {
      var v = matchVariant(selectedOptions());
      var btn = form.querySelector('[type="submit"]');
      var priceEl = document.getElementById("er-product-price");
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? "Rip It — " + formatMoney(v.price) : "Sold Out";
        }
      } else if (btn) {
        btn.disabled = true;
        btn.textContent = "Unavailable";
      }
    }
    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener("change", onVariantChange);
    });
    onVariantChange();
  })();

  /* ---------- Escape closes drawers ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeMobileNav();
      closeCartDrawer();
    }
  });

  /* init cart count on load */
  document.addEventListener("DOMContentLoaded", function () {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
    }).catch(function(){});
  });
})();
